module.exports = "<light-core-selector-item on-index-change=\"onIndexChange\" on-selected-index-change=\"onSlideChange\"></light-core-selector-item>\n\n<content></content>\n";
